module.exports = __webpack_public_path__ + "static/media/0010.0ac5ce4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0010.mp3
// module id = zFaL
// module chunks = 0